import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {Link} from 'react-router-dom';

const CryptoTable = ({data, columns}) => {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            {columns.map((item, i) => (
                <TableCell>
                    {item.title} 
                </TableCell>
                ))
            }
          </TableRow>
        </TableHead>
        <TableBody>
            {
                data.map((item, i) => (
                    <TableRow
                        key={item.uuid}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                        <TableCell component="th" scope="row">
                            <strong>
                                {
                                    <Link>
                                        {
                                            item.rank
                                        }
                                    </Link>
                                }
                            </strong>
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <strong>
                                {
                                    <Link to={`/crypto/currencies/${item.uuid}`}>
                                        {
                                            item.name
                                        }
                                    </Link>
                                }
                            </strong>
                        </TableCell>
                        <TableCell>
                            {item.price
                            ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.price)
                            :   "Nil" 
                            }
                        </TableCell>
                        <TableCell>
                            {
                                <span style={{color: `${item.change > 0 ? "green" : "red"}`}}> 
                                    <strong>{item.change} %</strong> 
                                </span>
                            }
                        </TableCell>
                        {
                            item['24hVolume']
                            ? <TableCell>
                                {new Intl.NumberFormat().format(item['24hVolume'])} 
                            </TableCell>  
                            : <></>
                        }
                    </TableRow>
                ))
            }
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default CryptoTable;